import { IConstructorOptions } from "../../../Utilities";
import { GetCorrelation } from "../../../ViewModel/Utilities";
import { BasicEntityWatcher } from "../EntityWatcher";
import { DataEntityBase } from "./Base/DataEntityBase";
import { Models } from "./Base/Models";




export enum FeedbackResponseProperties {

    csatResponse = '_csatResponse',
    npsResponse = '_npsResponse',

    constructiveFeedback = '_constructiveFeedback',
    positiveFeedback = '_positiveFeedback',

    easeOfUse = '_easeOfUse',
    technicalReliability = '_technicalReliability',
    featuresCapabilities = '_featuresCapabilities',
    visualAppeal = '_visualAppeal',
    speed = '_speed',

    tasksFeedback = '_taskFeedback',

    correlationId = '_correlationId',
}

export type TaskFeedback = {
    task: string,
    score: number | undefined
}


export class FeedbackResponse extends DataEntityBase {

    public static get TypeName() { return Models.FeedbackResponse; }

    public static CreateId() {
        return DataEntityBase.CreateId(FeedbackResponse.TypeName, FeedbackResponse.TypeName)
    };

    public static Create(watcher: BasicEntityWatcher, options?: IConstructorOptions) {
        var retVal = new FeedbackResponse(options);
        watcher.RegisterEntity(retVal);
        return retVal;
    }



    public get csatResponse(): number | undefined { return this[FeedbackResponseProperties.csatResponse]; }
    public set csatResponse(value: number) { this.UpdateAndFire(FeedbackResponseProperties.csatResponse, value); }
    [FeedbackResponseProperties.csatResponse] = undefined;

    public get npsResponse(): number | undefined { return this[FeedbackResponseProperties.npsResponse]; }
    public set npsResponse(value: number) { this.UpdateAndFire(FeedbackResponseProperties.npsResponse, value); }
    [FeedbackResponseProperties.npsResponse] = undefined;





    public get constructiveFeedback(): string | undefined { return this[FeedbackResponseProperties.constructiveFeedback]; }
    public set constructiveFeedback(value: string) { this.UpdateAndFire(FeedbackResponseProperties.constructiveFeedback, value); }
    [FeedbackResponseProperties.constructiveFeedback] = undefined;

    public get positiveFeedback(): string | undefined { return this[FeedbackResponseProperties.positiveFeedback]; }
    public set positiveFeedback(value: string) { this.UpdateAndFire(FeedbackResponseProperties.positiveFeedback, value); }
    [FeedbackResponseProperties.positiveFeedback] = undefined;




    public get easeOfUse(): number | undefined { return this[FeedbackResponseProperties.easeOfUse]; }
    public set easeOfUse(value: number) { this.UpdateAndFire(FeedbackResponseProperties.easeOfUse, value); }
    [FeedbackResponseProperties.easeOfUse] = undefined;

    public get technicalReliability(): number | undefined { return this[FeedbackResponseProperties.technicalReliability]; }
    public set technicalReliability(value: number) { this.UpdateAndFire(FeedbackResponseProperties.technicalReliability, value); }
    [FeedbackResponseProperties.technicalReliability] = undefined;

    public get featuresCapabilities(): number | undefined { return this[FeedbackResponseProperties.featuresCapabilities]; }
    public set featuresCapabilities(value: number) { this.UpdateAndFire(FeedbackResponseProperties.featuresCapabilities, value); }
    [FeedbackResponseProperties.featuresCapabilities] = undefined;

    public get visualAppeal(): number | undefined { return this[FeedbackResponseProperties.visualAppeal]; }
    public set visualAppeal(value: number) { this.UpdateAndFire(FeedbackResponseProperties.visualAppeal, value); }
    [FeedbackResponseProperties.visualAppeal] = undefined;

    public get speed(): number | undefined { return this[FeedbackResponseProperties.speed]; }
    public set speed(value: number) { this.UpdateAndFire(FeedbackResponseProperties.speed, value); }
    [FeedbackResponseProperties.speed] = undefined;




    public get tasksFeedback(): TaskFeedback[] { return this[FeedbackResponseProperties.tasksFeedback]; }
    public set tasksFeedback(value: TaskFeedback[]) { this.UpdateAndFire(FeedbackResponseProperties.tasksFeedback, value); }
    [FeedbackResponseProperties.tasksFeedback] = [];

    public get correlationId(): string | undefined { return this[FeedbackResponseProperties.correlationId]; }
    public set correlationId(value: string) { this.UpdateAndFire(FeedbackResponseProperties.correlationId, value); }
    [FeedbackResponseProperties.correlationId] = GetCorrelation().id;




    protected constructor(options?: IConstructorOptions) {

        super(
            {
                typename: FeedbackResponse.TypeName,
                serializationProperties: FeedbackResponseProperties,
                dateProperties: FeedbackResponse.completableDateProperties,
                jsonProperties: FeedbackResponse.completableJsonProperties
            });
        this.CompleteConstruction(options);
    }

    private static completableDateProperties: string[] = [
    ];


    private static completableJsonProperties: string[] = [
        FeedbackResponseProperties.tasksFeedback
    ];
}